import { c as _c } from "react/compiler-runtime";
import { useCouponOutcomes } from '@svenskaspelab/poolbetting/core/frameworks/nextjs/coupon';
import { type CouponId, type CouponIndex } from '@svenskaspelab/poolbetting/schema/coupon';
import type { ReactNode } from 'react';
import BetButtonsColumn from './BetButtonsColumn';

/**
 * Props for the BetButtonsColumnClientContainer component.
 * Contains identifiers needed to fetch and display coupon betting outcomes.
 */
type BetButtonsColumnProps = {
  /** Index/position of the coupon within a collection */
  couponIndex: CouponIndex;
  /** Unique identifier for the specific coupon */
  couponId: CouponId;
};

/**
 * Client-side container component that manages betting button column state and data.
 *
 * This component serves as a data-fetching wrapper for the BetButtonsColumn component.
 * It uses the useCouponOutcomes hook to retrieve selected betting outcomes for a specific
 * coupon and passes them to the presentation component.
 *
 * @param props - The component props
 * @param props.couponIndex - Index/position of the coupon within a collection
 * @param props.couponId - Unique identifier for the specific coupon
 * @returns JSX element containing the betting buttons column with current selections
 */
export default function BetButtonsColumnClientContainer(t0) {
  const $ = _c(6);
  const {
    couponIndex,
    couponId
  } = t0;
  let t1;
  if ($[0] !== couponId || $[1] !== couponIndex) {
    t1 = {
      couponId,
      boardIndex: 0,
      couponIndex
    };
    $[0] = couponId;
    $[1] = couponIndex;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const selectedOutcomes = useCouponOutcomes(t1);
  let t2;
  if ($[3] !== couponIndex || $[4] !== selectedOutcomes) {
    t2 = <BetButtonsColumn selectedOutcomes={selectedOutcomes} couponIndex={couponIndex} />;
    $[3] = couponIndex;
    $[4] = selectedOutcomes;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}